export default __webpack_public_path__ + "images/icons/learn-more-21e738e3386be57a5f70b97cda0f39f6.svg";